import * as Sentry from '@sentry/browser';

let sentryIsInitialized = false;
const releasePlaceholder = 'BUILD_NUMBER_PLACEHOLDER';

const init = (dsn) => {
  const sentryConfig = {
    dsn,
  };

  // eslint-disable-next-line no-underscore-dangle
  const release = window.__WS__BUILD_NUMBER;
  if (release !== releasePlaceholder) {
    sentryConfig.release = release;
  }

  Sentry.init(sentryConfig);
  sentryIsInitialized = true;
};
const isInit = () => sentryIsInitialized;

const setUserId = (id) => {
  if (id) {
    Sentry.configureScope((scope) => {
      scope.setUser({ id });
      // eslint-disable-next-line no-console
      console.info(`Sentry set user ID: ${id}`);
    });
  }
};

const captureException = (error, additionalInfo) => {
  if (!sentryIsInitialized) return;

  Sentry.withScope((scope) => {
    const { request, response } = error;
    scope.setExtras({
      ...(additionalInfo && { additionalInfo }),
      ...(request && { request: JSON.stringify(request) }),
      ...(response && { response: JSON.stringify(response) }),
    });
    Sentry.captureException(error);
  });
};

const getInstance = () => Sentry;

export default {
  init,
  getInstance,
  setUserId,
  isInit,
  captureException,
};
